import { API_PCAP_FILES_PATH } from '@shared/constants/pathsConstants';
import { PcapFilesSearchRequestParams } from '@pages/library/types';
import request from '@shared/api/request';

export function getPcapFiles(params: PcapFilesSearchRequestParams) {
    return request.get(`/${API_PCAP_FILES_PATH}/`, {
        params: {
            ...params,
            page_index: params?.page_index + 1,
        },
    });
}

export function downloadPcapFile(pk: number) {
    return request.get(`/${API_PCAP_FILES_PATH}/${pk}/download/`);
}
